import jwt_decode from 'jwt-decode';
import { TokenData } from 'store/slices/auth';

export const decodeToken = (jwt: string): TokenData => {
    const decoded = jwt_decode<TokenData>(jwt);

    return {
        ...decoded,
        data: {
            ...decoded.data,
            isSample: false, // enforce false for real users
        },
    };
};
